export const UPSERT_COLLECTIONS_MUTATION = `
  mutation UpsertCollections($objects: [collections_insert_input!]!) {
    insert_collections(
      objects: $objects
      on_conflict: {
        constraint: collections_firm_id_key
        update_columns: [luca_code, tl_bor, tl_alacak, tl_bakiye, import_date]
      }
    ) {
      affected_rows
      returning { id firm_id luca_code tl_bor tl_alacak tl_bakiye import_date }
    }
  }
`;

export const UPDATE_COLLECTION_MUTATION = `
  mutation UpdateCollection($id: Int!, $_set: collections_set_input!) {
    update_collections_by_pk(pk_columns: { id: $id }, _set: $_set) {
      id
    }
  }
`;

// Yüklenen Excel'de olmayan firmaların collections kayıtlarını siler.
// keepFirmIds: import edilen firmaların id listesi. Bu listede olmayan
// tüm collections (aynı şirket içinde) silinir.
export const DELETE_COLLECTIONS_NOT_IN_LIST_MUTATION = `
  mutation DeleteCollectionsNotInList($companyId: Int!, $keepFirmIds: [Int!]!) {
    delete_collections(where: {
      company_id: { _eq: $companyId },
      firm_id: { _nin: $keepFirmIds }
    }) {
      affected_rows
    }
  }
`;
